<template>
  <div>
    <div class="md-layout" style="margin-top: -24px;">
      <div class="md-layout-item md-medium-size-25 md-xsmall-size-50 md-size-25">
        <div class="card-link" @click="gotoRoute('messages')">
          <stats-card header-color="primary">
            <template slot="header">
              <div class="card-icon">
                <i class="fa fa-envelope" />
              </div>
              <p class="category">
                <span style="color: #777; font-size:.85rem;" />
              </p>
              <h3 class="title" style="color: #1565c0;" v-if="showScreeningsNumber">
                <animated-number :value="nMessages" />
              </h3>
              <h3 class="title" style="color: #1565c0;" v-if="!showScreeningsNumber">
                <md-progress-spinner :md-diameter="25" :md-stroke="3"  md-mode="indeterminate" />
              </h3>
            </template>

            <template slot="footer">
              <div class="stats" style="font-weight:400; font-size:.9rem;">
                MESSAGES
              </div>
            </template>
          </stats-card>
        </div>
      </div>

      <div class="md-layout-item md-medium-size-25 md-xsmall-size-50 md-size-25">
        <div class="card-link" @click="gotoRoute('screenings')">
          <stats-card header-color="primary">
            <template slot="header">
              <div class="card-icon">
                <i class="fa fa-eye" />
              </div>
              <p class="category">
                <span style="color: #777; font-size:.85rem;" />
              </p>
              <h3 class="title" style="color: #1565c0;" v-if="showScreeningsNumber">
                <animated-number :value="nAvailable" />
              </h3>
              <h3 class="title" style="color: #1565c0;" v-if="!showScreeningsNumber">
                <md-progress-spinner :md-diameter="25" :md-stroke="3"  md-mode="indeterminate" />
              </h3>
            </template>

            <template slot="footer">
              <div class="stats" style="font-weight:400; font-size:.9rem;">
                <!-- <md-icon>local_offer</md-icon>-->
                SCREENINGS
              </div>
            </template>
          </stats-card>
        </div>
      </div>

      <div class="md-layout-item md-medium-size-25 md-xsmall-size-50 md-size-25">
        <div class="card-link" @click="gotoRoute('onhold')">
          <stats-card header-color="primary">
            <template slot="header">
              <div class="card-icon">
                <i class="fas fa-user-md" />
              </div>
              <p class="category">
                <span style="color: #777; font-size:.85rem;" />
              </p>
              <h3 class="title" style="color: #1565c0;" v-if="showScreeningsNumber">
                <animated-number :value="nOnHold" />
              </h3>
              <h3 class="title" style="color: #1565c0;" v-if="!showScreeningsNumber">
                <md-progress-spinner :md-diameter="25" :md-stroke="3"  md-mode="indeterminate" />
              </h3>
            </template>

            <template slot="footer">
              <div class="stats" style="font-weight:400; font-size:.9rem;">
                ON-HOLD
              </div>
            </template>
          </stats-card>
        </div>
      </div>

      <div class="md-layout-item md-medium-size-25 md-xsmall-size-50 md-size-25">
        <div class="card-link" @click="gotoRoute('reports')">
          <stats-card header-color="primary">
            <template slot="header">
              <div class="card-icon">
                <md-icon>assignment</md-icon>
              </div>
              <p class="category">
                <span style="color: #777; font-size:.85rem;" />
              </p>
              <h3 class="title" style="color: #1565c0;" v-if="showScreeningsNumber">
                <animated-number :value="nOnHold" />
              </h3>
              <h3 class="title" style="color: #1565c0;" v-if="!showScreeningsNumber">
                <md-progress-spinner :md-diameter="25" :md-stroke="3"  md-mode="indeterminate" />
              </h3>
            </template>

            <template slot="footer">
              <div class="stats" style="font-weight:400; font-size:.9rem;">
                REPORTS
              </div>
            </template>
          </stats-card>
        </div>
      </div>
    </div>

    <div class="md-layout" style="margin-top: -12px;">
      <div class="md-layout-item md-size-100">
        <globe-activity-slim-card header-color="green">
          <template slot="header">
            <div class="card-icon">
              <md-icon>language</md-icon>
            </div>
            <b>
              <h4 class="title" style="font-size: 1.4em; font-weight: 300;">GlobeChek Activity</h4>
            </b>
          </template>

          <template slot="content">
            <div class="md-layout">
              <div class="md-layout-item" align="Left">
                <globe-activity-slim-table />
              </div>
            </div>
          </template>
        </globe-activity-slim-card>
      </div>
    </div>
  </div>
</template>

<script>
import { StatsCard, AnimatedNumber } from "@/components"
import GlobeActivitySlimCard from "@/components/GlobeChek/Cards/GlobeActivitySlimCard.vue"
import GlobeActivitySlimTable from "@/components/GlobeChek/Tables/GlobeActivitySlimTable.vue"
export default {
  components: {
    StatsCard,
    AnimatedNumber,
    GlobeActivitySlimCard,
    GlobeActivitySlimTable
  },
  data() {
    return {
      nMessages: 0,
      nAvailable: 0,
      nOnHold: 0,
      nReports: 0,
      showScreeningsNumber: false,
    }
  },
  created: function () {
    this.initDash()
    // this.$store.dispatch('loadReaderInfo')
  },
  computed: {
    numMessages() {
      return sessionStorage.getItem("readerMessages")
    },
    numAvailable() {
      return sessionStorage.getItem("readerAvailable")
    },
    numHold() {
      return sessionStorage.getItem("readerHold")
    },
    numReports() {
      return sessionStorage.getItem("readerReports")
    }
  },
  
  methods: {
    gotoRoute(r) {
      this.$router.push("/portal/reader/" + r)
    },
    initDash() {
      this.updtDashInfo()
    },
    async updtDashInfo() {
      const username = sessionStorage.getItem("username");
      const dashUrl = `${process.env.VUE_APP_URL}/reader-dash/${username}`
      const config = { headers: { "Content-Type": "application/json" } }
      const data = null
      this.showScreeningsNumber = false;

      const response = await window.axios.get(dashUrl, data, config).then(r => r.data);

      const [messages, screenings, onHold, reports] = response.split(',').map(Number);

      this.nMessages = messages;
      this.nAvailable = screenings;
      this.nOnHold = onHold;
      this.nReports = reports;
      this.showScreeningsNumber = true;

      sessionStorage.setItem("adminMessages", messages);
      sessionStorage.setItem("adminAvailable", screenings);
      sessionStorage.setItem("adminHold", onHold);
      sessionStorage.setItem("adminReports", reports);
    }
  }
}
</script>
